var _path, _path2, _path3, _path4, _rect, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicationBenefitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16Z",
    fill: "#D9E2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1663 21.6988V25.1217H23.5019C22.803 25.1217 22.123 24.9821 21.4997 24.7112C20.8763 24.4404 20.1964 24.3008 19.5069 24.3008L15.833 24.2844V21.6988C15.833 21.3213 16.0786 20.8042 16.3903 20.5333L18.3925 18.7931C18.5625 18.6454 18.6663 18.432 18.6663 18.2186V16.8396C18.8175 16.8888 18.9686 16.9135 19.1386 16.9135H23.8608C24.0308 16.9135 24.1819 16.8888 24.333 16.8396V18.2186C24.333 18.432 24.4369 18.6454 24.6069 18.7931L26.6091 20.5333C26.9208 20.8042 27.1663 21.3213 27.1663 21.6988Z",
    fill: "#FCEEEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9512 15.0959H19.0473C18.2333 15.0959 17.5762 15.5827 17.5762 16.1857C17.5762 16.6579 17.9881 17.0648 18.5569 17.2101C18.7139 17.2536 18.8708 17.2754 19.0473 17.2754H23.9512C24.1277 17.2754 24.2846 17.2536 24.4416 17.2101C25.0104 17.0648 25.4223 16.6579 25.4223 16.1857C25.4223 15.5827 24.7652 15.0959 23.9512 15.0959Z",
    fill: "#FB6F55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1663 21.2725L27.1663 28.0057C27.1663 28.9024 25.8913 29.6362 24.333 29.6362H18.6663C17.108 29.6362 15.833 28.9024 15.833 28.0057L15.833 21.2725C19.6301 21.2837 23.3906 21.2725 27.1663 21.2725Z",
    fill: "#F4B7A8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.02539,
    y: 16.1858,
    width: 15.7241,
    height: 6.90328,
    rx: 3.45164,
    transform: "rotate(-45.1291 5.02539 16.1858)",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5723 10.614L13.6839 7.48835C15.0288 6.13736 17.2142 6.13244 18.5652 7.47735C19.9162 8.82226 19.9211 11.0077 18.5762 12.3587L15.4646 15.4844L12.7466 12.7786L10.5723 10.614Z",
    fill: "#004BA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationBenefitLogo);
export default __webpack_public_path__ + "static/media/MedicationBenefitLogo.6fc5df3e9c63d4675cf4bd93f786398c.svg";
export { ForwardRef as ReactComponent };